import { StateManager } from '../stateManager';
import { SET_AUTHENTICATION, SET_USER_DETAILS, SET_ROLES } from './actions';
import { hasCookieToken } from '../../utils/CookieToken';

export const initialState = {
  isAuthenticated: false || hasCookieToken,
  userDetails: null,
};

const setAuthentication = (state, action) => {
  let isAuthenticated = action.isAuthenticated || hasCookieToken;
  return { ...state, isAuthenticated: isAuthenticated };
};

const setUserDetails = (state, action) => {
  let { userDetails } = action;
  return { ...state, userDetails: { ...userDetails } };
};

const setUserRoles = (state, action) => {
  let { roleDetails } = action;
  return { ...state, roleDetails: { ...roleDetails } };
};

const actions = {
  [SET_AUTHENTICATION]: setAuthentication,
  [SET_USER_DETAILS]: setUserDetails,
  [SET_ROLES]: setUserRoles,
};

const manager = new StateManager(initialState, actions);

export default manager.reducer;
